module.exports = __webpack_public_path__ + "img/sparks-yellow-small.4430de18.png";